export default __webpack_public_path__ + "static/online-lesson-51f8d182bf430c3a98085ab1a06e03f2.png";